<template>
  <div class="app">
    <div class="section cta"></div>

    <div class="section steps">
      <div class="section__wrapper">
        <div class="grid">
          <transition name="zoom" appear>
            <div class="grid__item">
              <div class="box">
                <div class="steps__number">1</div>
                <img class="steps__icon animated pulse infinite" src="@/assets/steps-icon-3.png" />
                <h1>Kup AGD marki MPM</h1>
                <p class="center">
                  za minimum 99 zł*<br />
                  w&nbsp;sklepie biorącym udział w akcji.
                </p>
              </div>
            </div>
          </transition>

          <transition name="zoom" appear>
            <div class="grid__item">
              <div class="box">
                <div class="steps__number">2</div>
                <img class="steps__icon animated pulse infinite" src="@/assets/steps-icon-2.png" />
                <h1>Oceń zakup</h1>
                <p class="center">
                  i napisz swoją opinię o zakupionym produkcie w sklepie sprzedawcy.
                </p>
              </div>
            </div>
          </transition>

          <transition name="zoom" appear>
            <div class="grid__item">
              <div class="box">
                <div class="steps__number">3</div>
                <img class="steps__icon animated pulse infinite" src="@/assets/steps-icon-1.png" />
                <h1>Zarejestruj opinię</h1>
                <p class="center">
                  i odbierz jedną z<br /><strong>trzech dostępnych nagród!</strong>
                </p>
              </div>
            </div>
          </transition>
        </div>

        <p class="small center">
          *Promocja trwa do 31.12.2026 lub do wyczerpania zapasów. Szczegóły oraz wykluczenia znajdziesz w <a href="regulamin.pdf" target="_blank">regulaminie</a>.
        </p>
      </div>
    </div>

    <div class="section prizes">
      <VBlock max-width="1071px"><img src="@/assets/prizes.png" /></VBlock>
    </div>

    <div class="section about">
      <div class="section__wrapper">
        <div class="about__content">
          <h1>Jak wziąć udział?</h1>

          <p>
            <strong>1. Kup AGD marki MPM za minimum 99 zł</strong> w sklepach
            stacjonarnych i internetowych u wybranych Sprzedawców, włączając
            <strong
              >Media Expert, RTV EURO AGD, Media Markt, Neonet, Avans, Electro.pl, MPM.PL, ALLEGRO,
              OleOle.pl</strong
            >
            lub poprzez stronę <strong>Ceneo.</strong>
          </p>
          <p>
            <strong
              >2. W ciągu 14 dni po zakupie wystaw opinię na stronie sklepu, w którym został
              dokonany zakup.</strong
            >
            Opinia musi składać się z minimum 120 znaków i być oznaczona hashtagiem:
            <strong>#OpiniaMPM2026</strong>
          </p>
          <p>
            <strong
              >3. Wyślij zgłoszenie za pomocą formularza dostępnego na tej stronie.</strong
            >
            W formularzu zgłoszeniowym należy załączyć
            <strong>screen/zdjęcie opinii</strong> umieszczonej na stronie sprzedawcy oraz
            <strong>dowód zakupu produktu.</strong>
          </p>
          <p>
            <strong
              >4. W zależności od kwoty na dowodzie zakupu możesz otrzymać jedną z trzech nagród: </strong
            >
            Termos Turystyczny STT-27 za zakup AGD MPM w przedziale 99&nbsp;&ndash;&nbsp;199,99&nbsp;zł, zestaw młynków do soli i pieprzu SMP-7/1 + SMP-7/2 za zakup AGD MPM w przedziale 200&nbsp;-&nbsp;399,99&nbsp;zł oraz zestaw noży SNS-6 za zakup AGD MPM za kwotę powyżej 400&nbsp;zł
          </p>
          <p>
            <strong>5.</strong> Po pozytywnej weryfikacji zgłoszenia,
            <strong>nagrodę wyślemy w ciągu 21 dni roboczych.</strong>
          </p>
          <p class="center">
            Promocja trwa do 31.12.2026 lub do wyczerpania zapasów.<br />Szczegóły znajdziesz w
            <a href="regulamin.pdf" target="_blank">regulaminie.</a>
          </p>


            
          <button class="button animated pulse infinite" @click="scrollTo('#form')">
            Zarejestruj opinię!
          </button>

          <!--<p class="center" style="font-size: 8px;">
            
          </p>-->
          
          <img class="about__photo" src="@/assets/about-photo.png" />
          <!-- <img class="about__product" src="@/assets/about-product.png" /> -->
        </div>
      </div>
    </div>

    <!-- <div class="section form" id="form">
      <div class="section__wrapper">
        <div class="form__content">
          <h1>Pula nagród już się skończyła.</h1>

          <p class="center">Dziękujemy wszystkim uczestnikom!</p>
        </div>
      </div>
    </div> -->

    <div class="section form" id="form">
      <div class="section__wrapper">
        <!-- <img src="https://www.facebook.com/tr?id=813445054156895&ev=ViewContent" height="1" width="1" style="display:none"/> -->

        <div class="form__content" v-if="!isSubmitted">
          <h1>Formularz zgłoszeniowy</h1>

          <form @submit.prevent ref="form" class="form__fields">
            <div class="form__field">
              <label>Imię i nazwisko *</label>
              <input type="text" required v-model="name" autocomplete="name" />
            </div>

            <div class="form__field">
              <label>Adres e-mail *</label>
              <input type="email" required v-model="email" autocomplete="email" />
            </div>

            <div class="form__field">
              <label>Numer telefonu *</label>
              <input type="tel" required pattern="[+\d\s]+" v-model="phone" autocomplete="tel" />
            </div>

            <div class="form__field form__field--margin-top">
              <label>Ulica *</label>
              <input type="text" required v-model="street" autocomplete="street-address" />
            </div>

            <div class="form__field form__field--50">
              <label>Numer domu *</label>
              <input type="text" required v-model="houseNumber" />
            </div>

            <div class="form__field form__field--50">
              <label>Numer mieszkania</label>
              <input type="text" v-model="flatNumber" />
            </div>

            <div class="form__field form__field--50">
              <label>Miasto *</label>
              <input type="text" required v-model="city" autocomplete="address-level2" />
            </div>

            <div class="form__field form__field--50">
              <label>Kod pocztowy *</label>
              <input
                type="tel"
                required
                pattern="[\d\-]*"
                v-model="postalCode"
                autoComplete="postal-code"
              />
            </div>

            <div class="form__field form__field--margin-top">
              <label>Sklep, w którym dokonano zakupu *</label>
              <select required v-model="shop">
                <option value="" disabled selected>Wybierz z listy</option>
                <option value="allegro">ALLEGRO</option>
                <option value="avans">Avans</option>
                <option value="ceneo">Ceneo</option>
                <option value="electro-pl">Electro.pl</option>
                <option value="media-expert">Media Expert</option>
                <option value="media-markt">Media Markt</option>
                <option value="mpm-pl">MPM.PL</option>
                <option value="neonet">Neonet</option>
                <option value="oleole-pl">OleOle.pl</option>
                <option value="rtv-euro-agd">RTV EURO AGD</option>
                <option value="sferis">Sferis</option>
                <option value="inny-sklep">Inny sklep</option>
              </select>
            </div>

            <div class="form__field">
              <label>Kwota zakupionych produktów MPM na dowodzie zakupu *</label>
              <input
                type="text"
                required
                inputmode="decimal"
                pattern="\d+(,\d{1,2})?"
                v-model="purchaseAmount"
                @input="onPurchaseAmountInput($event)"
              />
            </div>

            <div class="form__field">
              <label for="file1">
                Dodaj dowód zakupu <span v-if="file1">({{ file1.name }})</span>
              </label>

              <input
                type="file"
                id="file1"
                ref="file1Input"
                required
                @change="onFileChange($event.target.files, 'file1')"
              />
            </div>

            <div class="form__field">
              <label for="file2">
                Dodaj zrzut ekranu zamieszczonej opinii <span v-if="file2">({{ file2.name }})</span>
              </label>

              <input
                type="file"
                id="file2"
                ref="file2Input"
                required
                @change="onFileChange($event.target.files, 'file2')"
              />
            </div>

            <div class="form__field">
              <label for="consent1"
                >Zapoznałem/am się z treścią
                <a href="regulamin.pdf" target="_blank">Regulaminu promocji</a> oraz akceptuję jego
                postanowienia. *</label
              >
              <input id="consent1" type="checkbox" required v-model="consent1" />
            </div>

            <div class="form__field">
              <label for="consent2"
                >Wyrażam zgodę na przetwarzanie moich danych osobowych przez MPM AGD SPÓŁKA AKCYJNA
                dla potrzeb związanych z realizacją promocji. *</label
              >
              <input id="consent2" type="checkbox" required v-model="consent2" />
            </div>

            <div class="form__field">
              <label for="consent3"
                >Wyrażam zgodę na przetwarzanie danych osobowych do celów marketingowych sklepu
                MPM.PL określonych w
                <a href="https://mpm.pl/pl/content/20-polityka-prywatnosci" target="_blank"
                  >Polityce prywatności</a
                >. *</label
              >
              <input id="consent3" type="checkbox" required v-model="consent3" />
            </div>
          </form>

          <p class="center">
            <strong
              >Uzupełnienie pól oznaczonych gwiazdką (*) jest niezbędne do wzięcia udziału w
              promocji.</strong
            >
          </p>

          <button
            class="button button--alternative animated pulse infinite"
            @click="submit()"
            :disabled="isLoading"
          >
            <span v-if="!isLoading">Wyślij!</span>
            <span v-if="isLoading">Wysyłanie...</span>
          </button>
        </div>

        <div class="form__content form__content--success" v-if="isSubmitted && !hasErrored">
          <h1>Dziękujemy!</h1>

          <p class="center">
            Teraz musimy zweryfikować dostarczone przez Ciebie dokumenty zakupu oraz sprawdzić czy
            zostały spełnione wszystkie warunki otrzymania prezentu.
          </p>

          <p class="center">
            Weryfikacja trwa około dwóch
            dni roboczych, ale może się wydłużyć w przypadku dużej ilości zgłoszeń. O wyniku
            weryfikacji poinformujemy Cię w wiadomości mailowej.
          </p>

          <img src="@/assets/form-success.png" />

          <!-- <img src="https://www.facebook.com/tr?id=813445054156895&ev=SubmitApplication" height="1" width="1" style="display:none"/> -->
        </div>

        <div class="form__content" v-if="isSubmitted && hasErrored">
          <h1>Wystąpił błąd.</h1>

          <p class="center">Prosimy spróbować ponownie później.</p>
          <p class="center small" v-if="submissionId">ID błędu: {{ submissionId }}</p>
        </div>
      </div>
    </div>

    <div class="section products">
      <div class="section__wrapper">
        <h1>Potrzebujesz zakupowych inspiracji?</h1>
        <p class="center big"><span>Sprawdź nasze bestsellery!</span></p>

        <div class="grid">
          <div class="grid__item" v-for="product in currentProducts" :key="product.url">
            <transition name="zoom" appear>
              <a :href="product.url" target="_blank" class="box">
                <div
                  class="products__image"
                  :style="{
                    backgroundImage: `url('products/${product.photo}')`
                  }"
                />

                <h1>{{ product.name }}</h1>
                <p class="center">
                  <span>{{ product.code }}</span>
                </p>
              </a>
            </transition>
          </div>
        </div>

        <button
          v-if="canShowMoreProducts"
          class="button button--alternative animated pulse infinite"
          @click="showMoreProducts()"
        >
          Pokaż więcej!
        </button>
      </div>
    </div>

    <!--<div class="section cookies" v-if="!shouldHideCookies">
      <div class="section__wrapper">
        <p class="small center">
          Stosujemy Cookies oraz podobne technologie by zrozumieć w jaki sposób korzystasz z naszych
          usług.
        </p>

        <div class="cookies__buttons">
          <button
            class="button button--alternative button--small animated pulse infinite"
            @click="handleCookies(true)"
          >
            Zgoda
          </button>
          <button
            class="button button--alternative button--small animated pulse infinite"
            @click="handleCookies(false)"
          >
            Odrzuć
          </button>
        </div>
      </div>
    </div>-->
  </div>
</template>

<script>
import products from "@/products";
import Sentry from "@/sentry";

const createSubmissionId = () => `mpm-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

const getFileExtension = (file) => {
  if (!file || typeof file.name !== "string") {
    return "unknown";
  }

  const parts = file.name.split(".");

  if (parts.length < 2) {
    return "none";
  }

  return parts.pop().toLowerCase().slice(0, 16);
};

const getFileContext = (file, source = "state") => {
  if (!file) {
    return {
      hasFile: false,
      source
    };
  }

  return {
    hasFile: true,
    source,
    size: file.size,
    type: file.type || "unknown",
    extension: getFileExtension(file),
    lastModified: file.lastModified || null,
    ageMs: file.lastModified ? Date.now() - file.lastModified : null
  };
};

const getThrownValueType = (value) => Object.prototype.toString.call(value).slice(8, -1);

const getErrorMessage = (error) => {
  if (!error) {
    return "Form submission failed";
  }

  if (typeof error === "string") {
    return error;
  }

  if (typeof error.message === "string" && error.message) {
    return error.message;
  }

  return "Form submission failed";
};

const getErrorName = (error) => {
  if (error && typeof error.name === "string" && error.name) {
    return error.name;
  }

  return "FormSubmissionError";
};

const createMissingFileError = (fieldName) => {
  const error = new Error("Missing required file");

  error.name = "FormMissingFileError";
  error.code = "missing_file";
  error.fileField = fieldName;

  return error;
};

const getAxiosErrorContext = (error) => {
  if (!error || typeof error !== "object") {
    return {
      message: getErrorMessage(error),
      thrownType: getThrownValueType(error)
    };
  }

  const { config = {}, response = {} } = error || {};
  const { method, url, baseURL } = config;

  return {
    message: getErrorMessage(error),
    name: getErrorName(error),
    thrownType: getThrownValueType(error),
    code: error.code,
    fileField: error.fileField,
    method,
    url,
    baseURL,
    status: response.status,
    responseError: response.data && response.data.error
  };
};

const getBrowserContext = () => ({
  userAgent: navigator.userAgent,
  platform: navigator.platform,
  online: navigator.onLine,
  viewport: `${window.innerWidth}x${window.innerHeight}`
});

export default {
  name: "App",

  data() {
    const shouldHideCookies = JSON.parse(localStorage.getItem("shouldHideCookies") || false);

    return {
      name: "",
      email: "",
      phone: "",
      street: "",
      houseNumber: "",
      flatNumber: "",
      city: "",
      postalCode: "",
      shop: "",
      purchaseAmount: "",
      consent1: false,
      consent2: false,
      consent3: false,
      file1: undefined,
      file2: undefined,
      isLoading: false,
      isSubmitted: false,
      hasErrored: false,
      submissionId: "",
      currentProductsAmount: 3,
      products,
      shouldHideCookies
    };
  },

  computed: {
    canShowMoreProducts() {
      return this.currentProductsAmount < this.products.length;
    },

    currentProducts() {
      return this.products.slice(0, this.currentProductsAmount);
    }
  },

  methods: {
    showMoreProducts() {
      this.currentProductsAmount += 3;
    },

    scrollTo(selector) {
      const { parentIFrame } = window;

      if (parentIFrame) {
        parentIFrame.moveToAnchor(selector);

        return;
      }

      const element = document.querySelector(selector);

      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },

    onFileChange([file] = [], fieldName) {
      this.$set(this, fieldName, file);
    },

    getSelectedFile(fieldName) {
      const refName = `${fieldName}Input`;
      const input = this.$refs[refName];

      return this[fieldName] || (input && input.files && input.files[0]);
    },

    getFileInputContext(fieldName) {
      const refName = `${fieldName}Input`;
      const input = this.$refs[refName];
      const inputFile = input && input.files && input.files[0];

      return {
        state: getFileContext(this[fieldName], "state"),
        input: getFileContext(inputFile, "input"),
        inputFileCount: input && input.files ? input.files.length : 0,
        selectedSource: this[fieldName] ? "state" : (inputFile ? "input" : "none")
      };
    },

    onPurchaseAmountInput(event) {
      const { value } = event.target;
      let sanitizedValue = value
        .replace(/[^\d,\.]/g, "")
        .replace(/\./g, ",");

      const separatorIndex = sanitizedValue.indexOf(",");

      if (separatorIndex === -1) {
        sanitizedValue = sanitizedValue.replace(/,/g, "");
      } else {
        const integerPart = sanitizedValue.slice(0, separatorIndex).replace(/,/g, "");
        const decimalPart = sanitizedValue
          .slice(separatorIndex + 1)
          .replace(/,/g, "")
          .slice(0, 2);

        sanitizedValue = `${integerPart},${decimalPart}`;
      }

      this.purchaseAmount = sanitizedValue;
    },

    captureSubmitError(error, { submissionId, service, step }) {
      try {
        const sentryError = new Error(getErrorMessage(error));
        sentryError.name = getErrorName(error);

        Sentry.withScope((scope) => {
          scope.setTag("submissionId", submissionId);
          scope.setTag("formStep", step);
          scope.setTag("service", service);
          scope.setContext("submission", {
            id: submissionId,
            service,
            step,
            file1: this.getFileInputContext("file1"),
            file2: this.getFileInputContext("file2")
          });
          scope.setContext("request", getAxiosErrorContext(error));
          scope.setContext("browser", getBrowserContext());

          Sentry.captureException(sentryError);
        });
      } catch (sentryError) {
        window.console &&
          window.console.error &&
          window.console.error("Failed to report form submission error", sentryError);
      }
    },

    async submit() {
      if (this.isLoading) {
        return;
      }

      const isValid = this.$refs.form.checkValidity();

      if (!isValid) {
        if (this.$refs.form.reportValidity) {
          this.$refs.form.reportValidity();
        }

        return;
      }

      this.isLoading = true;
      this.submissionId = createSubmissionId();
      let currentStep = "validation";
      let currentService = "frontend";

      try {
        currentStep = "validate_files";
        const selectedFile1 = this.getSelectedFile("file1");
        const selectedFile2 = this.getSelectedFile("file2");

        if (!selectedFile1) {
          throw createMissingFileError("file1");
        }

        if (!selectedFile2) {
          throw createMissingFileError("file2");
        }

        this.file1 = selectedFile1;
        this.file2 = selectedFile2;

        currentStep = "upload_file1";
        currentService = "storage";
        const file1 = await this.$bricodes.uploadFile(selectedFile1, undefined, "file1");

        currentStep = "upload_file2";
        const file2 = await this.$bricodes.uploadFile(selectedFile2, undefined, "file2");

        const payload = {
          name: this.name,
          email: this.email,
          phone: this.phone,
          street: this.street,
          houseNumber: this.houseNumber,
          flatNumber: this.flatNumber,
          city: this.city,
          postalCode: this.postalCode,
          shop: this.shop,
          purchaseAmount: this.purchaseAmount,
          consent1: this.consent1,
          consent2: this.consent2,
          consent3: this.consent3,
          file1,
          file2
        };

        currentStep = "create_entry";
        currentService = "api";
        await this.$bricodes.createEntry({
          email: this.email,
          consent1: this.consent1,
          consent2: this.consent2,
          consent3: this.consent3,
          answer: JSON.stringify(payload)
        });

        window.gtag &&
          window.gtag("event", "Submitted", {
            event_category: "Form"
          });
      } catch (error) {
        this.hasErrored = true;
        this.captureSubmitError(error, {
          submissionId: this.submissionId,
          service: currentService,
          step: currentStep
        });

        window.gtag &&
          window.gtag("event", "Errored", {
            event_category: "Form"
          });
      }

      this.isSubmitted = true;
      this.isLoading = false;

      this.scrollTo("#form");
    },

    handleCookies(areCookiesAllowed) {
      this.shouldHideCookies = true;

      localStorage.setItem("shouldHideCookies", true);

      if (areCookiesAllowed) return;

      localStorage.setItem("disableCookies", true);
      window["ga-disable-G-VK1WGDZZS1"] = true;
      window.location.reload();
    }
  }
};
</script>

<style lang="scss">
@import "reset-css";
@import "~vue2-animate/dist/vue2-animate.min.css";
@import "~animate.css/animate.min.css";

@import url("https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap");

*,
*::before,
*::after {
  box-sizing: border-box;
}

.header,
.footer {
  background-color: #eeeeee;
  height: 200px;
}

.app {
  overflow: hidden;

  font-family: "Open Sans", Arial, Helvetica, sans-serif;
  font-size: font(18px, 40px);

  h1 {
    font-size: 32px;
    line-height: 1.25em;
    font-weight: 800;
    text-align: center;
    color: #000000;

    @media screen and (max-width: 1366px) {
      font-size: 24px;
    }
  }

  p {
    color: #000000;

    span {
      color: #60f262;
    }

    a {
      color: inherit;
    }

    &.center {
      text-align: center;
    }

    &.small {
      font-size: 16px;
      font-weight: 300;
    }

    &.big {
      font-size: 42px;
      font-weight: 800;
    }
  }

  &__logo {
    display: block;
    width: 100%;
    max-width: 200px;
    height: auto;
    margin: 50px auto;
    transform: translateX(-65px);

    @media screen and (max-width: 1366px) {
      transform: none;
    }
  }
}

.section {
  padding: 50px;

  &__wrapper {
    max-width: 1280px;
    margin: 0 auto;

    &--wide {
      max-width: 1920px;
    }
  }
}

.grid {
  display: flex;
  align-items: stretch;
  justify-content: center;
  flex-wrap: wrap;
  margin: -22px;

  &__item {
    flex: 1 1 33.3333%;
    max-width: 33.3333%;
    padding: 22px;

    @media screen and (max-width: 1024px) {
      flex: 1 1 50%;
      max-width: 50%;
    }

    @media screen and (max-width: 800px) {
      flex: 1 1 100%;
      max-width: 400px;
    }
  }
}

.box {
  padding: 50px 40px;

  border-radius: 25px;
  // border: solid 1px #404040;

  background-color: #231e6f;

  h1,
  p {
    color: #ffffff;
  }
}

.button {
  display: block;
  min-width: 350px;
  text-align: center;
  padding: 18px;
  margin: 0 auto;
  border-radius: 30px;
  color: #231e6f;
  font-size: 18px;
  font-weight: 800;
  font-family: inherit;
  text-decoration: none;
  // background-color: #a71931;
  background-color: #60f262;

  border: none;
  outline: none;

  cursor: pointer;

  @media screen and (max-width: 800px) {
    width: 100%;
  }

  @media screen and (max-width: 450px) {
    min-width: 0;
  }

  &:not(:first-child) {
    margin-top: 50px;
  }

  &:hover {
    color: #000000;
  }

  &--alternative {
    background-color: #231e6f;
    color: #ffffff;

    &:hover {
      color: #60f262;
      // background-color: #a71931;
    }
  }

  &--small {
    padding: 10px;
    min-width: 100px;
    font-size: 12px;
  }

  &:disabled {
    cursor: default;

    opacity: 0.5;
  }
}

.cta {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-top: 32%;

  background-image: url("~@/assets/cta-background.png");
  background-repeat: no-repeat;
  background-size: auto 100%;
  background-position: center center;

  background-color: #231e6f;

  // @media screen and (max-width: 1366px) {
  //   display: block;
  //   padding-left: 0;
  //   padding-right: 0;

  //   background-image: url("~@/assets/about-product.png");
  //   background-repeat: no-repeat;
  //   background-size: auto 25%;
  //   background-position: top 100px left 100px;
  // }

  // @media screen and (max-width: 1080px) {
  //   background-position: top 90px left 50px;
  // }

  // @media screen and (max-width: 800px) {
  //   background-position: top 100px left 10px;
  // }

  // @media screen and (max-width: 600px) {
  //   background-size: auto 20%;
  //   background-position: top 110px left 0;
  // }

  @media screen and (max-width: 450px) {
    padding-top: 23%;
  }

  // .section__wrapper {
  //   padding-left: 100px;

  //   @media screen and (max-width: 1366px) {
  //     padding-left: 0;
  //   }
  // }

  // &__photo {
  //   display: none;

  //   width: 100%;
  //   height: auto;

  //   @media screen and (max-width: 1366px) {
  //     display: block;

  //     margin-top: 50px;
  //   }
  // }

  // .section__wrapper {
  //   margin-left: 0;

  //   @media screen and (max-width: 1366px) {
  //     margin-left: auto;
  //   }
  // }

  // h1 {
  //   font-size: 80px;
  //   font-weight: bold;
  //   margin-left: -150px;

  //   @media screen and (max-width: 1366px) {
  //     margin-left: 0;
  //   }

  //   @media screen and (max-width: 1024px) {
  //     font-size: 60px;
  //   }

  //   span {
  //     display: inline-block;
  //     margin-right: 250px;

  //     @media screen and (max-width: 1366px) {
  //       margin-right: 0;
  //     }
  //   }
  // }

  // p {
  //   margin-top: 45px;
  //   font-weight: bold;

  //   text-shadow: 0 0 20px rgba(255, 255, 255, 1);

  //   strong {
  //     position: relative;

  //     color: #000000;

  //     &::after {
  //       content: "";

  //       position: absolute;
  //       top: 100%;
  //       left: 0;
  //       width: 105%;
  //       height: 10px;
  //       margin-top: -5px;

  //       background-image: url("~@/assets/underline.png");
  //       background-repeat: no-repeat;
  //       background-size: 100% 100%;

  //       @media screen and (max-width: 800px) {
  //         height: 5px;
  //         margin-top: 0;
  //       }
  //     }
  //   }
  // }
}

.steps {
  &__icon {
    display: block;

    height: 120px;
    width: auto;
    margin: 20px auto 0;
  }

  &__number {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%);

    width: 75px;
    height: 75px;

    border-radius: 9999px;

    background-color: #60f262;
    color: #231e6f;

    font-size: 25px;
    font-weight: 800;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;

    border: 10px solid #ffffff;
  }

  .grid {
    margin-top: 8px;
    margin-bottom: 8px;
  }

  .box {
    position: relative;
    padding: 50px 16px;
    height: 100%;
    box-sizing: border-box;

    border-bottom: 10px solid #60f262;

    h1 {
      margin-top: 50px;
      color: #60f262;

      @media screen and (max-width: 1366px) {
        height: auto;
      }
    }

    p {
      height: 3.75em;
      margin-top: 12px;

      font-size: 22px;
      line-height: 1.25em;
      font-weight: 300;

      strong {
        font-weight: 500;
      }

      @media screen and (max-width: 1366px) {
        height: auto;
      }
    }
  }
}

.about {
  margin-top: 50px;
  // overflow: hidden;

  position: relative;
  padding-top: 150px;
  padding-bottom: 150px;

  background-color: #231e6f;
  // background-image: url("~@/assets/about-background.png");
  // background-position: right center;
  // background-size: auto 100%;
  // background-repeat: no-repeat;

  // @media screen and (max-width: 1366px) {
  //   background-image: none;
  // }

  &__photo {
    position: absolute;
    height: 90%;
    width: auto;
    bottom: 0;
    left: 0;

    @media screen and (max-width: 1650px) {
      left: 0;
      height: 80%;
    }

    @media screen and (max-width: 1450px) {
      left: 0;
      height: 70%;
    }

    @media screen and (max-width: 1366px) {
      display: none;
    }
  }

  &__product {
    position: absolute;
    top: -100px;
    right: 5%;

    @media screen and (max-width: 1640px) {
      right: 0;
    }

    @media screen and (max-width: 1366px) {
      display: none;
    }
  }

  &::before {
    content: "";

    position: absolute;
    bottom: 100%;
    left: 50%;
    width: 105%;
    height: 80px;

    background-color: #ffffff;

    transform-origin: bottom right;
    transform: translate(-50%, 0) rotate(-2deg);
  }

  &::after {
    content: "";

    position: absolute;
    bottom: 0;
    left: 50%;
    width: 105%;
    height: 80px;

    background-color: #ffffff;
    transform-origin: bottom left;
    transform: translate(-50%, 0) rotate(2deg);
  }

  &__content {
    max-width: 700px;
    margin-left: auto;

    @media screen and (max-width: 1366px) {
      max-width: none;
    }
  }

  p {
    color: #ffffff;
  }

  h1 {
    color: #60f262;
    margin-bottom: 70px;
    text-align: left;

    @media screen and (max-width: 1366px) {
      text-align: center;
    }
  }

  p {
    font-size: 18px;
    line-height: 1.25em;
    width: 100%;

    &:not(:first-child) {
      margin-top: 20px;
    }

    strong {
      font-weight: 800;
    }
  }
}

.form {
  position: relative;
  padding: 50px 0 150px;

  background-color: #ffffff;
  background-image: url("~@/assets/form-background.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top center;

  p {
    margin-top: 50px;

    font-size: 14px;
    font-weight: bold;
  }

  &__content--success {
    p:not(:first-child) {
      margin-top: 25px;
    }

    img {
      display: block;
      width: 300px;
      height: auto;
      margin: 50px auto 0;
    }
  }

  @media screen and (max-width: 1850px) {
    background-position: left 90% center, center center;
  }

  @media screen and (max-width: 1600px) {
    background-position: left 98% center, center center;
  }

  @media screen and (max-width: 1400px) {
    background-size: 0 0, cover;
  }

  @media screen and (max-width: 1024px) {
    padding-bottom: 0;
  }

  &__content {
    max-width: 1024px;
    // min-height: 1000px;
    padding: 85px 120px;

    // margin-left: auto;

    background-color: #ffffff;
    border-radius: 25px;

    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);

    @media screen and (max-width: 1366px) {
      margin: 0 auto;
    }

    @media screen and (max-width: 1024px) {
      padding: 85px 50px;
      border-radius: 0;
    }
  }

  &__fields {
    display: flex;
    flex-wrap: wrap;

    margin: 50px -40px 0;
  }

  &__field {
    position: relative;

    flex: 1 1 100%;
    max-width: 100%;

    padding: 15px 40px;

    &--50 {
      flex: 1 1 50%;
      max-width: 50%;

      @media screen and (max-width: 1024px) {
        flex: 1 1 100%;
        max-width: 100%;
      }
    }

    &--margin-top {
      margin-top: 50px;
    }
  }

  label {
    position: absolute;
    top: 7px;
    left: 70px;
    font-size: 16px;
    padding: 0 10px;

    background-color: #ffffff;
  }

  input[type="text"],
  input[type="email"],
  input[type="tel"],
  select {
    display: block;
    width: 100%;

    padding: 15px 39px;

    font-family: inherit;
    font-size: 16px;

    border-radius: 32.5px;
    border: solid 1px #404040;

    background-color: #ffffff;

    outline: none;

    &:invalid {
      border-color: #a71931;
    }
  }

  select {
    padding-left: 35px;
  }

  &__field:has(:invalid) {
    label {
      color: #f3506c !important;
    }
  }

  &__field:has(input[type="file"]) {
    position: relative;

    input {
      position: absolute;
      left: -9999px;
    }

    label {
      position: static;
      display: block;
      width: 100%;
      text-align: center;
      padding: 18px;
      margin: 0 auto;
      border-radius: 30px;
      color: #ffffff;
      font-size: 18px;
      font-weight: 800;
      font-family: inherit;
      background-color: #5853ae;
      border: none;
      outline: none;

      cursor: pointer;

      &:not(:first-child) {
        margin-top: 50px;
      }

      &:hover {
        color: #60f262;
      }
    }
  }

  &__field:has(input[type="checkbox"]) {
    margin-top: 10px;

    padding: 5px 0 0 50px;

    label {
      position: static;
      display: block;
      padding: 0;

      font-size: 14px;
      line-height: 1.25em;
      min-height: 2.5em;

      a {
        color: inherit;
      }
    }

    input {
      position: absolute;
      top: 0;
      left: 0;

      width: 22px;
      height: 22px;
    }
  }
}

.products {
  position: relative;
  background-color: #ffffff;

  &::before {
    content: "";

    position: absolute;
    bottom: 100%;
    left: 50%;
    width: 105%;
    height: 80px;

    background-color: #ffffff;

    transform-origin: bottom right;
    transform: translate(-50%, 0) rotate(-2deg);
  }

  &__image {
    display: block;
    width: 90%;
    height: 200px;
    padding-top: 120%;
    margin: -50% auto 0;

    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;

    transition: transform 0.2s;
  }

  .grid {
    margin-top: 50px;
  }

  .box {
    display: block;
    text-decoration: none;
    margin-top: 70px;

    h1 {
      overflow: hidden;
      font-size: 30px;
      height: 2.5em;
    }

    p {
      margin-top: 10px;

      font-size: 20px;
      font-weight: 800;
    }
  }

  .box:hover .products__image {
    transform: scale(1.05);
  }
}

.cookies {
  &__buttons {
    display: flex;
    align-items: center;
    justify-content: center;

    .button {
      margin: 20px;
    }
  }
}
</style>
